/**
 * The contact list — the one contact endpoint slice 1 has.
 *
 * There is no create, edit or delete here because there is none on the API: a
 * contact exists because an import created it, and it is owned by the dataset
 * that did. Narrowing the list to one `datasetId` is what the dataset detail
 * screen uses to show what an upload actually produced.
 */
import {
  contactListResponseSchema,
  type ContactListQuery,
  type ContactListResponse,
} from '@wend/shared';

import { apiRequest } from './client';

export async function listContacts(
  query: ContactListQuery,
  signal?: AbortSignal,
): Promise<ContactListResponse> {
  return apiRequest({
    path: '/contacts',
    query: {
      page: String(query.page),
      pageSize: String(query.pageSize),
      sort: query.sort,
      direction: query.direction,
      ...(query.datasetId === undefined ? {} : { datasetId: query.datasetId }),
      ...(query.search === undefined || query.search === '' ? {} : { search: query.search }),
    },
    schema: contactListResponseSchema,
    signal,
  });
}
